import { parseDetails } from "./DelegationDetails";

const PHONE_DETAIL_REGEX =
  /(?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/;

export const extractPhoneFromDelegationDetails = (
  detailsJson?: string,
): string | null => {
  const details = parseDetails(detailsJson);

  for (const detail of details) {
    const match = detail.value?.match(PHONE_DETAIL_REGEX);
    if (match) {
      const digits = match[0].replace(/\D/g, "");
      if (digits.length === 10) return `+1${digits}`;
      if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
    }
  }

  return null;
};

export const formatDelegationPhoneForDisplay = (phone: string): string => {
  const digits = phone.replace(/\D/g, "");
  const national = digits.startsWith("1") ? digits.slice(1) : digits;

  if (national.length === 10) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(
      6,
    )}`;
  }

  return phone;
};
